import { useState, useEffect } from 'react';
import * as planApis from 'apis/plans';
import * as subscriptionApis from 'apis/subscriptions';
import New from './New';
import Large from './Large';
import Mini from './Mini';
import Modal from '../../common/Modal';
import Toggle from '../../common/Toggle';
import { useRazorpay } from "react-razorpay";
import { toast } from 'react-toastify';


const ConfirmCancelSubscription = ({ isOpen, onClose, openModal, handleCancelation }) => {
    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} size="small">
                <div className="p-300 ff-inter-medium fs-200">
                    Are you sure you want to cancel your subscription?

                    <div className="mt-200 flex jc-end">
                        <button className="btn-cancel" onClick={() => onClose(false)}>Keep Plan</button>
                        <button className="ml-100 btn-primary-outline" onClick={handleCancelation}>Cancel Subscription</button>
                    </div>
                </div>
            </Modal>
            <div className="flex jc-end p-200 mt-100">
                <a href="javascript:;" className="link text-bright-red ff-inter-light fs-150" onClick={openModal}>Cancel Subscription</a>
            </div>
        </>
    );
};


const ConfirmChangePlan = ({ isOpen, onClose, openModal, handlePlanChangeConfirmation, handleChangePlanCancelation }) => {
    console.log(isOpen);
    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} size="small">
                <div className="p-300 ff-inter-medium fs-200">
                    Are you sure you want to change your subscription?
                    <p className='ml-50'>*The UPI plan change requires starting a new subscription for the selected plan and completing the payment authorization. The refund will be issued based on proration. If the process is not completed, you will continue with your current plan.</p>
                    

                    <div className="mt-200 flex jc-end">
                        <button className="btn-cancel" onClick={() => {onClose(false);handleChangePlanCancelation()}}>Keep Plan</button>
                        <button className="ml-100 btn-primary-outline" onClick={()=>{onClose(false);handlePlanChangeConfirmation()}}>Change Plan </button>
                    </div>
                </div>
            </Modal>
        </>
    );
};

const Pricing = ({ context, isSubscriber, currentPlan }) => {
    const [plans, setPlans] = useState([]);
    const [isYearlyPayment, setIsYearlyPayment] = useState(false);
    const [subscription, setSubscription] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState();
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenChangePlan, setIsOpenChangePlan] = useState(false);
    const [paymentStatus, setPaymentStatus ] = useState("");
    

    const handleCancelation = async (isCanceled) => {
        setIsOpen(false);
        if (isCanceled) {
            try {
                await subscriptionApis.cancel();
                setSubscription(null);
                setSelectedPlan(null);
            } catch (error) {
                console.log(error);
            }
        }
    };

    const handleChangePlanCancelation = async () => {
        setIsOpenChangePlan(false);
        setSelectedPlan(subscription.plan.id)

        
    };

    const handleChangePlan = async (plan) => {
      setSelectedPlan(plan.id);
      setIsOpenChangePlan(true);
    };

    const handlePlanChangeConfirmation = async () =>{
        try {
            const { data: updatedSubscription } = await subscriptionApis.changePlan(selectedPlan);
            if (updatedSubscription?.razorpayKey) {
                subscriptionApis.updatChangePlanStatus({
                    razorpaySubscriptionId: updatedSubscription.razorpaySubscriptionId,
                    manualUpdateStatus: 'payment_triggered',
                });
                handlePayment(updatedSubscription, selectedPlan);
            } else {
                setSubscription(subscription)
                setSelectedPlan(subscription.plan.id);
            }
            
        } catch (error) {
            toast.error(error?.response?.data?.error);
            setSelectedPlan(subscription.plan.id)
        }
    }

    const { error, isLoading, Razorpay } = useRazorpay();

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  
   
  
    const handlePayment = ({razorpayKey, razorpaySubscriptionId:subscriptionId, email, phone}, planId) => {
        console.log(razorpayKey);
      const options = {
        key: razorpayKey,
  
        name: "The Taurian",
        description: "Subscription Payment",
        subscription_id: subscriptionId,
        image: "/your_logo.jpg",
        handler: async (response) => {
          console.log(response);
          const {razorpay_payment_id: paymentId, razorpay_subscription_id: subscriptionId,razorpay_signature:signature } = response;
          try{
            let verificationResponse;
            let shouldWait = true;
            let attempts = 0;
        
            while (shouldWait && attempts < 15) {
              attempts += 1;
              verificationResponse = await subscriptionApis.verify({
                paymentId,
                subscriptionId,
                signature
              });
        
              if (!verificationResponse.data?.wait) {
                shouldWait = false;
              } else {
                setPaymentStatus("waiting_for_confirmation"); 
                await delay(2000);
              }
            }

            if (shouldWait) {
              throw new Error('Payment verification timed out');
            }

            if (planId) {
              let switched = false;
              for (let attempt = 0; attempt < 15; attempt += 1) {
                const { data } = await subscriptionApis.fetchSubscription();
                if (Number(data?.plan?.id) === Number(planId)) {
                  setSubscription(data);
                  setSelectedPlan(data.plan.id);
                  switched = true;
                  break;
                }
                await delay(2000);
              }
              if (switched) {
                toast.success('Plan changed successfully.');
              } else {
                toast.success('Payment received. Your new plan will show here once the switch is confirmed.');
              }
            }
  
          }
          catch(error){
            alert(error);
          }
                  
        },
        prefill: {
          email,
          contact: phone,
        },
        theme: {
          color: "#F37254",
        },
        "modal": {
          "ondismiss": function () {
            subscriptionApis.updatChangePlanStatus({
                razorpaySubscriptionId: subscriptionId,
                manualUpdateStatus: 'payment_closed',
            });
            setSelectedPlan(subscription.plan.id)
            }
          }
  
      };
   
      const razorpayInstance = new Razorpay(options);
      razorpayInstance.open();
      razorpayInstance.on('payment.failed', function (response){
        toast.error("Your Payment Failed, Try again");
  });
    };
    

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const { data: plans } = await planApis.fetchPlans();
                setPlans(plans);

                if (isSubscriber) {
                    const { data: subscription } = await subscriptionApis.fetchSubscription();
                    setSubscription(subscription);
                    setSelectedPlan(subscription.plan.id);
                }
            } catch (error) {
                console.log(error);
            }
        };

        fetchPlans();
    }, [isSubscriber]);

    switch (context) {
        case 'large':
            return (
                <>
                    <div className="py-200 mb-300 px-150 flex jc-end ai-center">
                        <Toggle value={isYearlyPayment} onChange={v => setIsYearlyPayment(v)} />
                        <>{isOpen}</>
                    </div>

                    <Large
                        plans={plans}
                        subscription={subscription}
                        selectedPlan={selectedPlan}
                        handleChangePlan={handleChangePlan}
                    />
                    
                    {isSubscriber && <ConfirmCancelSubscription
                        isOpen={isOpen}
                        onClose={() => setIsOpen(false)}
                        openModal={() => setIsOpen(true)}
                        handleCancelation={handleCancelation}
                    />}
                     {isSubscriber && <ConfirmChangePlan
                        isOpen={isOpenChangePlan}
                        onClose={() => setIsOpenChangePlan(false)}
                        openModal={() => setIsOpenChangePlan(true)}
                        handlePlanChangeConfirmation={handlePlanChangeConfirmation}
                        handleChangePlanCancelation= {handleChangePlanCancelation}
                    />}

                </>
            )
        case 'mini':
            return (
                <>
                    <div className="pt-200 pb-300 flex jc-end ai-center">
                        <Toggle value={isYearlyPayment} onChange={v => setIsYearlyPayment(v)} />
                        <>{isOpen}</>
                    </div>

                    <Mini
                        plans={plans}
                        subscription={subscription}
                        selectedPlan={selectedPlan}
                        handleChangePlan={handleChangePlan}
                    />

                    {isSubscriber && <ConfirmCancelSubscription
                        isOpen={isOpen}
                        onClose={() => setIsOpen(false)}
                        openModal={() => setIsOpen(true)}
                        handleCancelation={handleCancelation}
                    />}
                     {isSubscriber && <ConfirmChangePlan
                        isOpen={isOpenChangePlan}
                        onClose={() => setIsOpenChangePlan(false)}
                        openModal={() => setIsOpenChangePlan(true)}
                        handlePlanChangeConfirmation={handlePlanChangeConfirmation}
                        handleChangePlanCancelation= {handleChangePlanCancelation}
                    />}
                </>
            );
        default:
            return <New plans={plans} />
    }
};

export default Pricing;